import { message } from "antd";
import { AxiosResponse } from "axios";

export default function ResponseAction(res: AxiosResponse){
    if (res.data.errno === 0) {
        return res.data.data;
    } else {
        message.error(res.data.errmsg);
        throw res.data.errmsg;
    }
}